// Copyright (c) RoochNetwork
// SPDX-License-Identifier: Apache-2.0

export enum MultiChainID {
  Bitcoin = 0,
  Ether = 60,
  Sui = 784,
  Nostr = 1237,
  Rooch = 20230101,
}
